<!-- Note :  this page is used from PNI to Edge redirect only  to controll the api calls-->

<div class="overlay_spinner" *ngIf="isSpinner" style="
Z-INDEX: 1099;">
  <img src="../../assets/img/loaders/loader.svg" alt="loader">
</div>